import { EMPTY_VALUE } from '../constants/styles';
import { formatPercent } from './string';

/**
 * Показывает долю целевого исхода (0..1) процентом. Неизвестная доля показывается прочерком:
 * решение, чем заменить отсутствующее значение, принадлежит форматтеру — иначе каждое место
 * показа выбирало бы замену само и они бы разошлись.
 */
export const formatTargetRate = (rate: number | null | undefined): string =>
  rate == null ? EMPTY_VALUE : formatPercent(rate * 100);
